import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { GcTextComponent, IpoTranslatePipe } from '@ip-only/front-end-library';

import { Feature } from 'geojson';
import { Subject } from 'rxjs';
import { DistributionPointProperties } from '../../../../../span-progress-app/span-progress-entities';
import { getFormattedYearMonthDate } from '../../../../util/date-helper';
import { RolloutProgressReportEntities } from '../../../service/entities';
import { RolloutProgressReportsService } from '../../../service/reports/rollout-progress-reports.service';

@Component({
  selector: 'app-report-info-v2',
  imports: [GcTextComponent, IpoTranslatePipe],
  templateUrl: './report-info.component.html',
  styleUrl: './report-info.component.scss',
})
export class ReportInfoComponent implements OnInit, OnDestroy {
  @Input() distributionPointProperties:
    | Feature<GeoJSON.Point, DistributionPointProperties>
    | undefined;

  private readonly cancelSub$ = new Subject<void>();

  lastUpdatedByString = '-';
  pointType: RolloutProgressReportEntities.v3.MarkerTypes;
  reportStatus: RolloutProgressReportEntities.v3.ReportStatus;

  constructor(private readonly reportService: RolloutProgressReportsService) {}

  ngOnInit(): void {
    this.getReportResponse();
  }

  ngOnDestroy(): void {
    this.cancelSub$.next();
  }

  getReportResponse() {
    if (this.distributionPointProperties?.properties.id) {
      this.setReportData(this.reportService.storedReportData());
    }
  }

  setReportData(res: RolloutProgressReportEntities.v3.ReportResponse) {
    this.setLastUpdatedByString(res.lastUpdateAt, res.updatedBy);
    this.pointType = res.type;
    this.reportStatus = res.status;
  }

  setLastUpdatedByString(lastUpdatedAt: Date | undefined, updatedBy: string) {
    if (lastUpdatedAt && updatedBy) {
      this.lastUpdatedByString = `${getFormattedYearMonthDate(lastUpdatedAt.toString())} ${updatedBy}`;
    } else {
      this.lastUpdatedByString = '-';
    }
  }

  get objectName() {
    return `${this.distributionPointProperties?.properties.telematorId} (${this.distributionPointProperties?.properties.name})`;
  }
}
